// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClickCheckbox_container__eRPuj {
  --border: 2px;
  --size: 1em;
  --distance: 3px;
}
.ClickCheckbox_container__eRPuj .ClickCheckbox_title__dyNNy {
  font-weight: var(--bold);
  padding: 0;
  margin: 0;
}
.ClickCheckbox_container__eRPuj .ClickCheckbox_helpText__\\+z0Ju {
  margin-top: 0;
  font-size: 0.75em;
}
.ClickCheckbox_container__eRPuj .ClickCheckbox_checkable__oSYvT {
  display: flex;
  align-items: center;
  --margin: 0.25em;
}
.ClickCheckbox_container__eRPuj input {
  font-size: 1em;
  position: relative;
  width: var(--size);
  height: var(--size);
  margin: 0;
}
.ClickCheckbox_container__eRPuj input:before {
  position: absolute;
  content: "";
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: var(--background-color-1);
  border: var(--border) solid var(--foreground-color-1);
}
.ClickCheckbox_container__eRPuj input:checked:after {
  content: "";
  --distance: 0.25em;
  position: absolute;
  left: var(--distance);
  right: var(--distance);
  top: var(--distance);
  bottom: var(--distance);
  background: var(--foreground-color-2);
}
.ClickCheckbox_container__eRPuj input:focus {
  outline: none;
}
.ClickCheckbox_container__eRPuj label {
  position: relative;
}
.ClickCheckbox_container__eRPuj:not(.ClickCheckbox_switch__oNRbd) label {
  margin-left: var(--margin);
}
.ClickCheckbox_container__eRPuj:not(.ClickCheckbox_switch__oNRbd) input.focus-visible + label:before {
  --focusWeight: 4px;
  --leftDistance: calc(
    var(--size) + var(--margin) + var(--focusWeight)
  );
  content: "";
  position: absolute;
  top: calc(-0.5 * var(--focusWeight));
  bottom: calc(-0.5 * var(--focusWeight));
  right: calc(-1 * var(--focusWeight));
  left: calc(-1 * var(--leftDistance));
  border: 4px solid var(--foreground-color-2-alpha);
}

.ClickCheckbox_container__eRPuj.ClickCheckbox_dark__PSXNu {
  color: var(--background-color-1);
}
.ClickCheckbox_container__eRPuj.ClickCheckbox_dark__PSXNu input:before {
  border: 1px solid var(--background-color-1);
}
.ClickCheckbox_container__eRPuj.ClickCheckbox_dark__PSXNu p {
  color: inherit;
}

.ClickCheckbox_container__eRPuj.ClickCheckbox_switch__oNRbd {
  --size: calc(var(--height) - calc(2 * var(--distance)) - 2 * var(--border));
  --height: 1.5em;
  --distance: calc(1 * var(--border));
}
.ClickCheckbox_container__eRPuj.ClickCheckbox_switch__oNRbd input {
  position: absolute;
  left: -1000000px;
}
.ClickCheckbox_container__eRPuj.ClickCheckbox_switch__oNRbd input:checked + label .ClickCheckbox_switch__oNRbd {
  background: var(--background-color-2);
}
.ClickCheckbox_container__eRPuj.ClickCheckbox_switch__oNRbd input:checked + label .ClickCheckbox_switch__oNRbd::before {
  left: calc(var(--height) + var(--distance));
  background: var(--background-color-1);
}
.ClickCheckbox_container__eRPuj.ClickCheckbox_switch__oNRbd input.focus-visible + label .ClickCheckbox_switch__oNRbd::before {
  content: "";
  box-shadow: 0 0 0 4px var(--foreground-color-2-alpha);
}
.ClickCheckbox_container__eRPuj.ClickCheckbox_switch__oNRbd input:checked.focus-visible + label .ClickCheckbox_switch__oNRbd::before {
  box-shadow: 0 0 0 4px var(--background-color-1-alpha);
}
.ClickCheckbox_container__eRPuj.ClickCheckbox_switch__oNRbd label {
  display: flex;
  align-items: center;
}
.ClickCheckbox_container__eRPuj.ClickCheckbox_switch__oNRbd label .ClickCheckbox_switch__oNRbd {
  position: relative;
  display: block;
  border: var(--border) solid var(--foreground-color-1);
  width: calc(2 * var(--height));
  height: var(--height);
  border-radius: calc(var(--height) / 2);
  background: var(--background-color-1);
  transition: all 0.3s;
}
.ClickCheckbox_container__eRPuj.ClickCheckbox_switch__oNRbd label .ClickCheckbox_switch__oNRbd::before {
  content: "";
  position: absolute;
  border-radius: 50%;
  background: var(--foreground-color-1);
  width: var(--size);
  top: var(--distance);
  bottom: var(--distance);
  left: var(--distance);
  transition: all 0.3s ease-in-out;
}
.ClickCheckbox_container__eRPuj.ClickCheckbox_switch__oNRbd label p {
  margin-left: var(--margin);
}

.ClickCheckbox_errorMessage__EbSst {
  font-size: 0.75em;
  color: var(--danger);
  min-height: 1rem;
}

.nightMode .ClickCheckbox_container__eRPuj.ClickCheckbox_switch__oNRbd input:checked + label .ClickCheckbox_switch__oNRbd {
  background: var(--foreground-color-2);
}`, "",{"version":3,"sources":["webpack://./src/components/Form/ClickCheckbox.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,eAAA;AACF;AAAE;EACE,wBAAA;EACA,UAAA;EACA,SAAA;AAEJ;AAAE;EACE,aAAA;EACA,iBAAA;AAEJ;AAAE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAEJ;AAAE;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;AAEJ;AADI;EACE,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,qCAAA;EACA,qDAAA;AAGN;AADI;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,oBAAA;EACA,uBAAA;EACA,qCAAA;AAGN;AADI;EACE,aAAA;AAGN;AAAE;EACE,kBAAA;AAEJ;AACI;EACE,0BAAA;AACN;AAGQ;EACE,kBAAA;EACA;;GAAA;EAGA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,uCAAA;EACA,oCAAA;EACA,oCAAA;EACA,iDAAA;AADV;;AAQA;EACE,gCAAA;AALF;AAME;EACE,2CAAA;AAJJ;AAME;EACE,cAAA;AAJJ;;AAQA;EACE,2EAAA;EACA,eAAA;EACA,mCAAA;AALF;AAME;EACE,kBAAA;EACA,gBAAA;AAJJ;AAOM;EACE,qCAAA;AALR;AAOM;EACE,2CAAA;EACA,qCAAA;AALR;AASM;EACE,WAAA;EACA,qDAAA;AAPR;AAWM;EACE,qDAAA;AATR;AAaE;EACE,aAAA;EACA,mBAAA;AAXJ;AAYI;EACE,kBAAA;EACA,cAAA;EACA,qDAAA;EACA,8BAAA;EACA,qBAAA;EACA,sCAAA;EACA,qCAAA;EACA,oBAAA;AAVN;AAWM;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,qCAAA;EACA,kBAAA;EACA,oBAAA;EACA,uBAAA;EAEA,qBAAA;EACA,gCAAA;AAVR;AAcI;EACE,0BAAA;AAZN;;AAiBA;EACE,iBAAA;EACA,oBAAA;EACA,gBAAA;AAdF;;AAkBE;EACE,qCAAA;AAfJ","sourcesContent":[".container {\n  --border: 2px;\n  --size: 1em;\n  --distance: 3px;\n  .title {\n    font-weight: var(--bold);\n    padding: 0;\n    margin: 0;\n  }\n  .helpText {\n    margin-top: 0;\n    font-size: 0.75em;\n  }\n  .checkable {\n    display: flex;\n    align-items: center;\n    --margin: 0.25em;\n  }\n  input {\n    font-size: 1em;\n    position: relative;\n    width: var(--size);\n    height: var(--size);\n    margin: 0;\n    &:before {\n      position: absolute;\n      content: \"\";\n      top: 0;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      background: var(--background-color-1);\n      border: var(--border) solid var(--foreground-color-1);\n    }\n    &:checked:after {\n      content: \"\";\n      --distance: 0.25em;\n      position: absolute;\n      left: var(--distance);\n      right: var(--distance);\n      top: var(--distance);\n      bottom: var(--distance);\n      background: var(--foreground-color-2);\n    }\n    &:focus {\n      outline: none;\n    }\n  }\n  label {\n    position: relative;\n  }\n  &:not(.switch) {\n    label {\n      margin-left: var(--margin);\n    }\n    input {\n      &:global(.focus-visible) + label {\n        &:before {\n          --focusWeight: 4px;\n          --leftDistance: calc(\n            var(--size) + var(--margin) + var(--focusWeight)\n          );\n          content: \"\";\n          position: absolute;\n          top: calc(-0.5 * var(--focusWeight));\n          bottom: calc(-0.5 * var(--focusWeight));\n          right: calc(-1 * var(--focusWeight));\n          left: calc(-1 * var(--leftDistance));\n          border: 4px solid var(--foreground-color-2-alpha);\n        }\n      }\n    }\n  }\n}\n\n.container.dark {\n  color: var(--background-color-1);\n  input:before {\n    border: 1px solid var(--background-color-1);\n  }\n  p {\n    color: inherit;\n  }\n}\n\n.container.switch {\n  --size: calc(var(--height) - calc(2 * var(--distance)) - 2 * var(--border));\n  --height: 1.5em;\n  --distance: calc(1 * var(--border));\n  input {\n    position: absolute;\n    left: -1000000px;\n\n    &:checked {\n      & + label .switch {\n        background: var(--background-color-2);\n      }\n      & + label .switch::before {\n        left: calc(var(--height) + var(--distance));\n        background: var(--background-color-1);\n      }\n    }\n    &:global(.focus-visible) + label .switch {\n      &::before {\n        content: \"\";\n        box-shadow: 0 0 0 4px var(--foreground-color-2-alpha);\n      }\n    }\n    &:checked:global(.focus-visible) + label .switch {\n      &::before {\n        box-shadow: 0 0 0 4px var(--background-color-1-alpha);\n      }\n    }\n  }\n  label {\n    display: flex;\n    align-items: center;\n    .switch {\n      position: relative;\n      display: block;\n      border: var(--border) solid var(--foreground-color-1);\n      width: calc(2 * var(--height));\n      height: var(--height);\n      border-radius: calc(var(--height) / 2);\n      background: var(--background-color-1);\n      transition: all 0.3s;\n      &::before {\n        content: \"\";\n        position: absolute;\n        border-radius: 50%;\n        background: var(--foreground-color-1);\n        width: var(--size);\n        top: var(--distance);\n        bottom: var(--distance);\n\n        left: var(--distance);\n        transition: all 0.3s ease-in-out;\n      }\n    }\n\n    p {\n      margin-left: var(--margin);\n    }\n  }\n}\n\n.errorMessage {\n  font-size: 0.75em;\n  color: var(--danger);\n  min-height: 1rem;\n}\n\n:global(.nightMode) {\n  .container.switch input:checked + label .switch {\n    background: var(--foreground-color-2);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ClickCheckbox_container__eRPuj`,
	"title": `ClickCheckbox_title__dyNNy`,
	"helpText": `ClickCheckbox_helpText__+z0Ju`,
	"checkable": `ClickCheckbox_checkable__oSYvT`,
	"switch": `ClickCheckbox_switch__oNRbd`,
	"dark": `ClickCheckbox_dark__PSXNu`,
	"errorMessage": `ClickCheckbox_errorMessage__EbSst`
};
export default ___CSS_LOADER_EXPORT___;
